import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useMap } from "react-map-gl";
import { useActiveProjectQuery } from "src/hooks/useActiveProjectQuery";

export const MapUtilAreaOfInterestCenter = observer(() => {
  const project = useActiveProjectQuery();
  const map = useMap();

  useEffect(() => {
    if (!project.data?.areaOfInterest || !map.current) return;
    const lat = project.data.areaOfInterest.latitude;
    const lng = project.data.areaOfInterest.longitude;
    map.current?.setCenter([lng, lat]);
  }, [map, project.data?.areaOfInterest]);
  return null;
});
